import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/atendimento-recepcao`

    return {
        index(queryParms = {}) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        create(queryParms) {
            return repository.get(`${baseUrl}/create?${urlUtil.serialize(queryParms)}`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        fila(queryParms) {
            return repository.get(`${baseUrl}/fila?${urlUtil.serialize(queryParms)}`)
        },
    }
}